<template>
    <div class="w-full h-full relative">
        <div class="flex items-center">
            <custom-input
                v-if="isOpenInput"
                v-model="keyword"
                class="w-full min-w-0"
                :label="`Nueva ${label} (Separa por ',')`"
                :disabled="!enabled"
                @enter="addNewKeyword"
            />
            <custom-multiple-select
                v-else
                v-model="keywords"
                mode="search"
                :label="label"
                class="w-full min-w-0"
                :options="keywordsOptions"
                :disabled="!enabled"
                @change="onInput"
            />

            <app-button v-if="enabled" icon border @click="changeActionKeys">
                {{ isOpenInput ? "✔️" : "➕" }}
            </app-button>
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomMultipleSelect from "@/components/utils/CustomMultipleSelect.vue";

export default {
    name: "KeywordsSelector",
    components: { CustomInput, CustomMultipleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        label: {
            type: String,
            default: () => "",
            required: true
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        },
        base: {
            type: Array,
            default: () => [],
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["change"],
    data: () => ({
        keywords: [],
        isOpenInput: false,
        keyword: "",
        keywordsBase: []
    }),
    computed: {
        keywordsOptions() {
            return this.keywordsBase.map((item) => ({
                label: item,
                value: item
            }));
        }
    },
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        setInput(value) {
            this.keywordsBase = [...this.base, ...value].filter(
                (value, index, self) =>
                    self.findIndex((item) => item === value) === index
            );
            this.keywords = [...value];
            this.isOpenInput = !this.keywords.length;
        },
        addNewKeyword() {
            if (this.keyword) {
                const keywords = this.keyword.split(", ");
                this.keywordsBase = [...keywords, ...this.keywordsBase];
                this.keywords = [...keywords, ...this.keywords];
                this.keyword = "";
                this.onInput();
            }
            this.isOpenInput = false;
        },
        changeActionKeys() {
            if (this.isOpenInput) {
                this.addNewKeyword();
            } else {
                this.isOpenInput = true;
            }
        },
        onInput() {
            this.$emit("change", this.keywords);
        }
    }
};
</script>
